import React, { useState, useEffect, useRef, useCallback } from 'react';
import { NavLink as Link } from 'redux-first-router-link';
import { connect } from 'react-redux';
import { isUndefined, values, isEmpty, isFunction, isArray, get, isBoolean } from 'lodash';
import SubMenu from './subMenu-item.js';
import { sendEventTrackingData } from '../../../../../../../helpers/commonUtils.js';
import MDTContext from '../../../../../../../helpers/contextHelper.js';
import { MDTApp } from '../../../../../../../actions/bootAction.js';
import { IconSet } from '../../../../../../atoms/mdt-iconset/index.js';
import { userInfoSucessLanguageUpdate } from '../../../../../../../actions/MeActions.js';
import { MDTAnalytics } from '../../../../../../../services/mdtanalytics.js';
import { MDTApi } from '../../../../../../../services/mdtapi.js';
import constants from '../../../../../../../helpers/constants.js';

import './navbar-item.css';

export const NavbarItem = (props) => {
    const {
        t,
        meState,
        layoutConfig,
        className,
        defaultApp,
        setShowLevel0,
        menuOpen,
        setMenuOpen,
        redirectTo,
        hyphenizedCulture,
        menuNewIcon,
    } = props;
    const [showSubMenu, setShowSubMenu] = useState(false);
    const [openMeatBallMenu, setOpenMeatBallMenu] = useState(false);
    const [showMeatBallIcon, setShowMeatBallIcon] = useState(false);
    const [selectedSubMenuName, setSelectedSubMenuName] = useState('');
    const componentWrapRef = useRef(null);
    const componentMainRef = useRef(null);
    const componentMoreMenuRef = useRef(null);
    const prevWidthRef = useRef(window.innerWidth);

    let { pageName } = props;
    const name = pageName.toLowerCase();
    const currentLang =
        !!localStorage.getItem('I18N_LANGUAGE_CMS') &&
        localStorage.getItem('I18N_LANGUAGE_CMS') !== 'undefined'
            ? localStorage.getItem('I18N_LANGUAGE_CMS')
            : 'en';

    const handleResize = useCallback(() => {
        const currentWidth = window.innerWidth;
        let isScreenExpanding = false;
        if (currentWidth > prevWidthRef.current) {
            isScreenExpanding = true;
        }
        prevWidthRef.current = currentWidth;
        if (window.innerWidth >= constants.DESKTOP_WIDTH) {
            const minAvailablespace = 600;
            let navwidth = 30;
            const compRef = componentMainRef;
            const outerWrapWidth =
                componentWrapRef.current && componentWrapRef.current.offsetWidth
                    ? componentWrapRef.current.offsetWidth
                    : 0;
            const morewidth =
                componentMoreMenuRef.current && componentMoreMenuRef.current.offsetWidth
                    ? componentMoreMenuRef.current.offsetWidth
                    : 0;

            if (compRef.current) {
                navwidth = [...compRef.current.children].reduce((totalWidth, child) => {
                    return totalWidth + child.offsetWidth;
                }, navwidth);
            }
            const availablespace = outerWrapWidth - morewidth;
            if (
                compRef.current &&
                compRef.current.className === 'main' &&
                (minAvailablespace > navwidth || outerWrapWidth < navwidth || isScreenExpanding)
            ) {
                if (navwidth > outerWrapWidth) {
                    const listItem = document.querySelectorAll('.main > div:not(.mdtnavbar-more)');
                    const lastItem = listItem[listItem.length - 1];
                    document
                        .querySelector('.main .mdtnavbar-more .meatball-menu')
                        .prepend(lastItem);
                    handleResize();
                    setShowMeatBallIcon(true);
                } else {
                    const firstMoreElement = document.querySelector(
                        '.main .mdtnavbar-more .meatball-menu .mdtnavbar-item'
                    );
                    if (
                        firstMoreElement &&
                        navwidth + firstMoreElement.offsetWidth < availablespace
                    ) {
                        document
                            .querySelectorAll('.main > div:last-child')[0]
                            .before(firstMoreElement);
                    }
                    setShowMeatBallIcon(false);
                }
                setShowMeatBallIcon(
                    !!(componentMoreMenuRef.current?.children?.[1]?.childElementCount > 0)
                );
            }
        }
    }, []);

    useEffect(() => {
        handleResize();

        const i18n = window.next18;
        i18n.on('languageChanged', () => {
            if (
                componentWrapRef.current &&
                componentMainRef.current &&
                componentMoreMenuRef.current
            ) {
                setTimeout(handleResize, 500);
            }
        });

        window.addEventListener('resize', handleResize);
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            window.removeEventListener('resize', handleResize);
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [handleResize]);

    useEffect(() => {
        setTimeout(handleResize, 500);
    }, [hyphenizedCulture]);

    useEffect(() => {
        if (props.toggleMenu) {
            props.toggleMenu(false);
        }
    }, [showSubMenu, props]);

    useEffect(() => {
        !menuOpen && setShowSubMenu(false);
    }, [menuOpen]);

    const handleClickOutside = (event) => {
        if (componentWrapRef.current && !componentWrapRef.current.contains(event.target)) {
            if (window.innerWidth >= constants.DESKTOP_WIDTH) {
                closeMenu();
            }
        }
    };

    const closeMenu = () => {
        setShowSubMenu(false);
        props.toggleMenu(false);
        setOpenMeatBallMenu(false);
        setMenuOpen(false);
    };

    const toggleSubmenu = (items) => {
        let isShowSubMenu = !showSubMenu;

        if (
            selectedSubMenuName &&
            selectedSubMenuName !== getlabelName(items.label) &&
            !isShowSubMenu
        ) {
            isShowSubMenu = showSubMenu;
        }
        if (props.toggleMenu) {
            props.toggleMenu(isShowSubMenu, true);
        }
        setShowSubMenu(isShowSubMenu);
        setSelectedSubMenuName(isShowSubMenu ? items && getlabelName(items.label) : '');
    };

    const checkAvailability = (permissions, roles, logicalOperation) => {
        if (isUndefined(permissions) && isUndefined(roles)) {
            return true;
        }
        if (isArray(permissions) && isArray(roles)) {
            // if both permissions and roles array
            const getResourceArray = permissions.map((item) =>
                props.getResourceAccess(item.resource, item.action)
            );
            return (
                getResourceArray.every((resource) => resource) &&
                roles.some((role) => props.userRoles.includes(role))
            );
        }
        if (isArray(permissions)) {
            // if permissions array only
            const getResourceArray = permissions.map((item) =>
                props.getResourceAccess(item.resource, item.action)
            );
            if (logicalOperation && logicalOperation === 'any') {
                return getResourceArray.some((resource) => resource);
            }
            return getResourceArray.every((resource) => resource);
        }
        if (isArray(roles)) {
            // if roles array only
            if (permissions && permissions.resource) {
                // if permissions object exists along with roles array
                return (
                    props.getResourceAccess(permissions.resource, permissions.action) &&
                    roles.some((role) => props.userRoles.includes(role))
                );
            }
            return roles.some((role) => props.userRoles.includes(role));
        }
        // if permissions object only
        return props.getResourceAccess(permissions.resource, permissions.action);
    };

    const checkUserType = (data) => {
        if (isUndefined(data)) {
            return true;
        }
        if (isBoolean(data)) {
            const { isInternalUser } = props;
            const isUserTypeValid = (isInternalUser && data) || (!isInternalUser && !data);
            return isUserTypeValid;
        }
        return false;
    };

    const checkSubmenu = (linkname) => {
        pageName = pageName.toLowerCase();
        const linkName = linkname.toLowerCase();

        // cache all layout items with subitems -- we need a non-reference copy here
        const topLevelLinks = values(props.layoutConfig);
        const parents = [];
        topLevelLinks.forEach((topLevelLink) => {
            if (topLevelLink.submenu) {
                parents.push(topLevelLink);
            }
        });

        // loop through parents to see if pageName is inside one of the parents.
        let pageIsSubMenuItem = false;
        let foundParent = {};

        for (let i = 0; i < parents.length; i++) {
            foundParent = parents[i];
            const submenu = values(parents[i].submenu);

            for (let j = 0; j < submenu.length; j++) {
                if (submenu[j].link && submenu[j].link.toLowerCase() === pageName) {
                    pageIsSubMenuItem = true;
                    break;
                }
            }

            if (pageIsSubMenuItem) break;
            else foundParent = {};
        }
        return (
            (pageIsSubMenuItem &&
                foundParent.link &&
                foundParent.link.toLowerCase() === linkName) ||
            pageName === linkName
        );
    };

    const getParentNode = (el, tagName, classNames) => {
        while (el && el.parentNode) {
            el = el.parentNode;
            if (el && el.tagName === tagName.toUpperCase() && el.classList.contains(classNames)) {
                return el;
            }
        }

        return null;
    };

    const sideBarOnClick = (e, selectedSubMenuName, level2MenuName) => {
        if (!props.expanded && e.target && !getParentNode(e.target, 'div', 'meatball-menu')) {
            setOpenMeatBallMenu(false);
        }
        const eventParamObj = {
            eventCategory: selectedSubMenuName ? 'globalHeader' : 'cta',
            eventAction:
                selectedSubMenuName && level2MenuName
                    ? `${selectedSubMenuName} | ${level2MenuName}`
                    : selectedSubMenuName && !level2MenuName
                      ? selectedSubMenuName
                      : 'globalHeader',
            processActions: !selectedSubMenuName,
            eventLabel: `${get(e, 'currentTarget.innerText', 'NA')}`,
            processLabels: false,
        };

        if (getParentNode(e.target, 'ul', 'submenu')) {
            setShowSubMenu(false);
            setOpenMeatBallMenu(false);
        }
        sendEventTrackingData(eventParamObj);
    };

    const isVisible = (visibility) => {
        if (typeof visibility === 'undefined') {
            return true;
        }
        if (typeof visibility === 'function') {
            return visibility(props.getResourceAccess, props.meState);
        }
        return visibility;
    };
    const isNewTag = (nav) => {
        return get(menuNewIcon, nav, false);
    };
    const newTagCreate = () => {
        const newText = t('newTag');
        if (newText.length > 6) {
            return <span className='new-tag-text icon-circleFilled' title={newText} />;
        }
        return (
            <span className='new-tag-text' title={newText}>
                {newText}
            </span>
        );
    };

    const updateUserProfile = (selectedLang) => {
        const data = {
            Culture: {
                key: selectedLang,
            },
        };
        MDTApi.setDefaultPathVar('userId', props.userId);
        MDTApi.call('api.common.user', {
            method: 'PATCH',
            data,
            successCallback: handleSuccessData,
        });
    };

    const handleSuccessData = (res) => {
        props.languages(res.culture);
    };

    const changeValue = (langKey, langValue) => {
        const { loggedIn } = props;

        localStorage.setItem('I18N_LANGUAGE', langKey);
        localStorage.setItem('I18N_LANGUAGE_CMS', langKey);
        if (loggedIn) updateUserProfile(langKey);
        if (window.next18) {
            window.next18.changeLanguage(langKey);
            MDTAnalytics.track({
                siteInfo: {
                    siteLanguage: langValue,
                },
            });
        }
        const eventParamObj = {
            eventCategory: 'navigation',
            eventAction: 'languageSelected',
            eventLabel: langValue,
            processLabels: false,
        };
        sendEventTrackingData(eventParamObj);
    };

    const openMeatballMenuFunc = (e) => {
        e.preventDefault();
        setShowSubMenu(false);
        setOpenMeatBallMenu(!openMeatBallMenu);
    };

    const getlabelName = (label) => {
        return isFunction(label) ? label(meState) : t(label);
    };

    const exitportalId = layoutConfig?.dashboard?.id || '';
    const exitportalSubMenuId = layoutConfig?.portal?.id || '';
    const isExitportalIconVisible = (menuItemId) => {
        if (
            defaultApp !== constants.PORTAL &&
            (menuItemId === exitportalId || menuItemId === exitportalSubMenuId)
        ) {
            return false;
        }
        return true;
    };

    const redirectToLink = (link, hash) => {
        if (hash) {
            const pageLink = MDTApp.getSetting(`links.${link}`) || ''; // add page link in app-settings -> links object
            if (pageLink) {
                const URL = pageLink.split('/')[pageLink.split('/').length - 1];
                props?.history?.push({
                    pathname: pageLink,
                    hash,
                });
                return redirectTo(URL.toUpperCase());
            }
            return console.error(
                'Page link not found in app-settings -> "links" object, please add it to it and try again'
            );
        }
        const linkValue = t(link);
        linkValue.includes('http') ? window.open(linkValue) : redirectTo(link.toUpperCase());
    };

    const handleOnClick = (e, items) => {
        e.preventDefault();
        !items.submenu && sideBarOnClick(e);
        if (items.link && !items.link.includes('javascript')) {
            closeMenu();
            redirectToLink(items.link, items.hash);
        } else if (items.onclick) {
            items.onclick(MDTApp, t);
        } else {
            if (!items.submenu) {
                props.toggleMenu(false, null);
            } else {
                setSelectedSubMenuName(getlabelName(items.label || 'nav.main'));
                toggleSubmenu(items);
            }
            if (items.menuType === 'languageSelector') {
                setShowLevel0(false);
            }
        }
    };

    // TODO: This is not valid JSX and react is throwing an error 20231017:Alevale
    return (
        <>
            <MDTContext.Consumer key='subItem-LS'>
                {(toggleSidebar) => (
                    <div className='mdtnavbar-wrapper' ref={componentWrapRef}>
                        <div className={className} ref={componentMainRef}>
                            {!isEmpty(layoutConfig) &&
                                values(layoutConfig).map((items, ItemIndex) => {
                                    const showHeaderItems =
                                        checkUserType(items.isInternalUser) &&
                                        checkAvailability(
                                            items.available,
                                            items.roles,
                                            items.logicalOperation
                                        ) &&
                                        isVisible(items.visible) &&
                                        isExitportalIconVisible(items.id);
                                    return (
                                        showHeaderItems && (
                                            <div
                                                className={`mdtnavbar-item ${items.link && checkSubmenu(items.link) ? 'active' : ''} ${showSubMenu && selectedSubMenuName === getlabelName(items.label) ? ' expand' : ''} ${items.desktopOnly ? ' d-none d-md-inline' : ''}${items.mobileonly ? 'd-block d-sm-none d-md-none' : ''}${items.mobiletabletonly ? 'd-block d-sm-block d-md-none' : ''}`}
                                                key={`item-${ItemIndex}`}
                                            >
                                                <a
                                                    className={`${isNewTag(items.label) ? 'new-tag-link' : ''}`}
                                                    onClick={(e) => handleOnClick(e, items)}
                                                    role='button'
                                                    tabIndex={0}
                                                    data-test={items.dataTest}
                                                    onKeyDown={() => {}}
                                                >
                                                    {!items.icon && items.submenu && (
                                                        <IconSet
                                                            name='arrow_right'
                                                            className='expand-icon'
                                                        />
                                                    )}
                                                    {items.icon && (
                                                        <IconSet
                                                            name={
                                                                isFunction(items.icon)
                                                                    ? items.icon(meState)
                                                                    : items.icon
                                                            }
                                                            title={t(items.title)}
                                                        />
                                                    )}
                                                    {items.icon &&
                                                        isFunction(items.badgeCount) &&
                                                        items.badgeCount(meState) && (
                                                            <span name='badge' className='badge'>
                                                                {items.badgeCount(meState)}
                                                            </span>
                                                        )}
                                                    <span
                                                        className={`label navLabel w-h-emphasis ${isNewTag(items.label) ? 'new-tag' : ''}`}
                                                    >
                                                        {getlabelName(items.label)}
                                                        {isNewTag(items.label) && newTagCreate()}
                                                        {items.menuType === 'languageSelector' &&
                                                        !isEmpty(toggleSidebar.languageSelectorData)
                                                            ? toggleSidebar.languageSelectorData.filter(
                                                                  (x) => x.key === currentLang
                                                              )[0]
                                                                ? toggleSidebar.languageSelectorData.filter(
                                                                      (x) => x.key === currentLang
                                                                  )[0].value
                                                                : ''
                                                            : ''}
                                                    </span>
                                                    {(items.submenu ||
                                                        items.menuType === 'languageSelector') && (
                                                        <IconSet
                                                            name='arrow_right'
                                                            className='expand-icon'
                                                        />
                                                    )}
                                                </a>
                                                {items.submenu &&
                                                    items.menuType !== 'languageSelector' && (
                                                        <SubMenu
                                                            t={t}
                                                            data={items.submenu}
                                                            pageName={pageName}
                                                            showSubMenu={showSubMenu}
                                                            setShowSubMenu={setShowSubMenu}
                                                            defaultApp={defaultApp}
                                                            layoutConfig={layoutConfig}
                                                            selectedSubMenuName={
                                                                selectedSubMenuName
                                                            }
                                                            className={className}
                                                            items={items}
                                                            sideBarOnClick={sideBarOnClick}
                                                            toggleMenu={props.toggleMenu}
                                                            setShowLevel0={setShowLevel0}
                                                            menuOpen={menuOpen}
                                                            checkAvailability={checkAvailability}
                                                            redirectToLink={redirectToLink}
                                                            closeMenu={closeMenu}
                                                        />
                                                    )}
                                                {/* Language Selector Data */}
                                                {items.menuType === 'languageSelector' &&
                                                    !isEmpty(
                                                        toggleSidebar.languageSelectorData
                                                    ) && (
                                                        <ul
                                                            className={
                                                                showSubMenu &&
                                                                selectedSubMenuName ===
                                                                    getlabelName(items.label)
                                                                    ? 'submenu expand'
                                                                    : 'submenu'
                                                            }
                                                        >
                                                            {selectedSubMenuName && (
                                                                <li className='mdtnavbar-item back d-block d-md-none'>
                                                                    <IconSet
                                                                        name='arrow_left'
                                                                        className='expand-icon'
                                                                    />
                                                                    <a
                                                                        className='label navLabel w-h-emphasis'
                                                                        href='#'
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            setShowSubMenu(false);
                                                                            setShowLevel0(true);
                                                                        }}
                                                                    >
                                                                        {selectedSubMenuName}
                                                                    </a>
                                                                </li>
                                                            )}
                                                            {values(
                                                                toggleSidebar.languageSelectorData
                                                            ).map(
                                                                (subItem, subIndex) =>
                                                                    subItem.value && (
                                                                        <li
                                                                            key={subIndex}
                                                                            className={`${
                                                                                subItem.mobileonly
                                                                                    ? 'd-block d-sm-none d-md-none'
                                                                                    : ''
                                                                            } ${
                                                                                subItem.link &&
                                                                                name ===
                                                                                    subItem.link.toLowerCase()
                                                                                    ? ' active'
                                                                                    : ''
                                                                            } ${
                                                                                subItem.mobiletabletonly
                                                                                    ? 'd-block d-sm-block d-md-none'
                                                                                    : ''
                                                                            }`}
                                                                        >
                                                                            <Link
                                                                                to='#'
                                                                                onClick={() => {
                                                                                    props.toggleMenu(
                                                                                        false,
                                                                                        null
                                                                                    );
                                                                                    changeValue(
                                                                                        subItem.key,
                                                                                        subItem.value
                                                                                    );
                                                                                }}
                                                                            >
                                                                                <span className='label body2 w-h-emphasis'>
                                                                                    {subItem.value}
                                                                                </span>
                                                                            </Link>
                                                                        </li>
                                                                    )
                                                            )}
                                                        </ul>
                                                    )}
                                            </div>
                                        )
                                    );
                                })}
                            {className === 'main' && (
                                <div
                                    className={`${
                                        showMeatBallIcon ? 'd-md-inline' : 'd-none'
                                    } mdtnavbar-more`}
                                    ref={componentMoreMenuRef}
                                >
                                    <button
                                        type='button'
                                        className='meatball-menu-icon'
                                        onClick={(e) => {
                                            openMeatballMenuFunc(e);
                                        }}
                                        data-test='mdtnavbar-more-button'
                                    >
                                        <IconSet
                                            name='dots-three-vertical'
                                            dataTest='icon-dots-three-vertical'
                                        />
                                    </button>
                                    <div
                                        className={`${
                                            openMeatBallMenu ? '' : 'd-none'
                                        } meatball-menu`}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </MDTContext.Consumer>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        meState: state,
        userRoles: get(state, 'meDetails.roles'),
        pageName: state.location.type,
        pageType: get(state, 'page', ''),
        userId: get(state, 'meDetails.user.sub', null),
        isInternalUser: get(state, 'meDetails.isInternal', false),
        defaultApp: state.meDetails.user?.defaultApp,
        hyphenizedCulture: get(state, 'meDetails.hyphenizedCulture', ''),
        menuNewIcon: get(state, 'formConfig.featureConfiguration.MenuNewIcon.configuration', {}),
        history: state?.locationChangeReducer?.history,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        redirectTo: (page, data) => dispatch({ type: page, payload: { filter: data } }),
        getResourceAccess: (resource, action) =>
            dispatch(MDTApp.getResourceAccess(resource, action)),
        languages: (lng) => dispatch(userInfoSucessLanguageUpdate(lng)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavbarItem);
